module.exports = __webpack_public_path__ + "c4c5df296e1d8c201fd61020cd10a639.svg";